/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { KTSVG } from '../../../../../../_metronic/helpers';
import { DateComplete } from '../../../../../utils/date';
import { initialLetters } from '../../../../../utils/initialLetters';
import { NotImported } from '../../../../components/NotInformat';
import { CatalogItemImage } from '../../../../catalogo/components/CatalogItemImage';
import { NuklieConversationButton } from '../../../../components/Nuklie';
import { formatCNPJ, formatCPF } from '../../../../../utils/formats';

type Props = {
    clients: any[];
    setMyClient: any;
    setShowCreateAppModal: any;
    setShowCreateAppModalDelete: any
    setShowCreateAppModalDetails: any
    onEditUser?: (client: any) => void
}

/** Aplica máscara de CPF (11 dígitos) ou CNPJ (14 dígitos); outros valores ficam como vieram. */
const formatDocument = (value: string) => {
    const digits = String(value || '').replace(/\D/g, '');
    if (digits.length === 11) return { text: formatCPF(digits), label: 'CPF do cliente' };
    if (digits.length === 14) return { text: formatCNPJ(digits), label: 'CNPJ do cliente' };
    return { text: value, label: 'Documento do cliente' };
};

export function TableBody({
    clients,
    setMyClient,
    setShowCreateAppModal,
    setShowCreateAppModalDelete,
    setShowCreateAppModalDetails,
    onEditUser
}: Props) {

    const [largura, setLargura] = useState(window.innerWidth);

    const handleButtonClickDelete = (event, client) => {
        event.stopPropagation();
        //unitBranch.idUser = unitBranch.users.length > 0 ? unitBranch.users[0].id : null; 
        setMyClient(client)
        setShowCreateAppModalDelete(true)
    };

    const handleButtonClickUpdate = (event: any, client: any) => {
        event.stopPropagation();
        client.idUser = client.user ? client.user.id : null; 
        client.idUnitBranch = client.unitBranchs && client.unitBranchs.length > 0 ? client.unitBranchs[0].id : null;
        client.idsPlants = client.plants && client.plants.length > 0 ? client.plants.map((plant: any) => plant.id) : null;
        setMyClient(client)
        setShowCreateAppModal(true)
    };


    const atualizarTamanhoDaTela = () => {
        setLargura(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener('resize', atualizarTamanhoDaTela);
        return () => {
          window.removeEventListener('resize', atualizarTamanhoDaTela);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  return (
    <tbody>
        {clients && clients.length !== 0 ?   
            clients.map((client: any) => {
                return (
                    <tr 
                        onClick={() =>{
                            setMyClient(client)
                            setShowCreateAppModalDetails(true)
                        }}
                    >
                        {/* <td>
                            <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                <input className='form-check-input widget-9-check' type='checkbox' value='1' />
                            </div>
                        </td> */}

                        <td>
                            <div className='d-flex align-items-center'>
                            <div className='me-4'>
                                <CatalogItemImage
                                  imageKey={client.image}
                                  fallbackIcon='/media/icons/duotune/communication/com006.svg'
                                />
                            </div>
                            {
                            <div className='d-flex justify-content-start flex-column'>
                                <a href='#' className='text-dark fw-bold text-hover-primary fs-6'>
                                    {client.nameResponsible ? client.nameResponsible : <NotImported className="fs-6 text-gray-400 text-hover-primary"/>}
                                </a>
                                <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                    {client.created_at ? DateComplete(new Date(client.created_at)) : <NotImported className="fs-6 text-gray-400 text-hover-primary"/>}
                                </span>
                            </div>
                            }
                            </div>
                        </td>

                        <td>
                            {client.cpfResponsible ?
                                <div>
                                    <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6 text-nowrap'>
                                        {formatDocument(client.cpfResponsible).text}
                                    </a>
                                    <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                        {formatDocument(client.cpfResponsible).label}
                                    </span>
                                </div>
                                : <NotImported className="fs-6 text-gray-400 text-hover-primary"/>
                            }
                        </td>

                        <td>
                            {client.email ?
                            <div>
                                <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                    {client.email}
                                </a>
                                <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                    E-mail de contato
                                </span>
                            </div> : <NotImported className="fs-6 text-gray-400 text-hover-primary"/>}
                        </td>

                        <td>
                            {client.user ? (
                            <div
                                role='button'
                                tabIndex={0}
                                title='Editar usuário de acesso'
                                className='d-inline-flex align-items-center rounded px-2 py-1 bg-hover-light-primary'
                                style={{gap: '1rem', marginLeft: '-0.5rem'}}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    onEditUser?.(client);
                                }}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        onEditUser?.(client);
                                    }
                                }}
                            >
                                <div className='symbol symbol-40px symbol-circle'>
                                    <span className={`symbol-label bg-light-primary text-primary fs-4 fw-bolder`}>
                                        {initialLetters(client.user.name)}
                                    </span>
                                </div>

                                <div>
                                    <span className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                        {client.user.name}
                                    </span>
                                    <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                        {client.user.email}
                                    </span>
                                </div>
                            </div>
                            )
                            :
                            (
                                <div>
                                    <NotImported className="fs-6 text-gray-400 text-hover-primary"/>
                                </div>
                            )
                        }
                            
                        </td>
                        

                        <td>
                            <div className='d-flex justify-content-end flex-shrink-0'>
                            <NuklieConversationButton resource='client' id={client.id} className='me-1' />
                            {/* <a
                                href='#'
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            >
                                <KTSVG
                                path='/media/icons/duotune/general/gen019.svg'
                                className='svg-icon-3'
                                />
                            </a> */}
                            <a
                                onClick={(event: any) =>{
                                    handleButtonClickUpdate(event, client)
                                }}
                                href='#'
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                            >
                                <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                            </a>
                            <a
                                onClick={(event: any) => {
                                    handleButtonClickDelete(event, client)
                                }}
                                href='#'
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                            >
                                <KTSVG
                                path='/media/icons/duotune/general/gen027.svg'
                                className='svg-icon-3'
                                />
                            </a>
                            </div>
                        </td>
                    </tr>
                )
            })
        :
        <tr>
            <td colSpan={largura < 1200 ? 2 : 6} style={{textAlign: 'center'}}>
                <div className='d-flex justify-content-center' style={{padding: '2rem'}}>
                    <span className='text-muted fw-semibold text-muted d-block fs-4'>
                        Clientes não encontrados!
                    </span>
                </div>
            </td>
        </tr>
        }
    </tbody>
  );
}